export const sliderSettings = {
  infinite: false,
  dots: true,
  arrows: false,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  className: 'app-preview-slick',
};
